import { usePortalLocaleQueries } from '@/hooks/usePortalLocaleQueries';
import { RouterProvider } from 'react-router-dom';
import { Suspense } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { router } from './router';
import { queryClient } from '@/lib/queryClient';
import { useTenantMeta } from '@/hooks/useTenantMeta';
import { useUIStore } from '@/store/uiStore';
import { PageLoader } from '@/components/ui/Spinner';
import { UI_TIMING } from '@heglo/ui/tokens';

function TenantMetaLoader() {
  usePortalLocaleQueries();
  useTenantMeta();
  return null;
}

function App() {
  const language = useUIStore((s) => s.language);

  return (
    <QueryClientProvider client={queryClient}>
        <TenantMetaLoader />
        <Suspense
          fallback={<PageLoader />}
        >
          <RouterProvider router={router} />
        </Suspense>
        <ToastContainer
          position={language === 'ar' ? 'top-left' : 'top-right'}
          autoClose={UI_TIMING.toastDurationMs}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={language === 'ar'}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </QueryClientProvider>
  );
}

export default App;
